// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"10a00ab7","225":"75b831b3","621":"0dd153ba","743":"9cfb79ac","986":"25b06873"}[chunkId] + ".chunk.js";
};